export interface PartnerOrganization {
    id: string;
    partnerId: string;
    referenceId: string;
    organizationId: string;
    divisionId: string;
    legacyOrganizationId: number;
    hubspotCompanyId: string;
    personaInquiryId: string;
    legacyOrganizationCreationSuccess: PartnerOrganizationStatus;
    connectorCreationSuccess: PartnerOrganizationStatus;
    connectorRunSuccess: PartnerOrganizationStatus;
    hubspotCompanyCreationSuccess: PartnerOrganizationStatus
    personaInquiryCreationStatus: PartnerOrganizationStatus;
    personaInquiryCompletionStatus: PartnerOrganizationStatus;
    welcomeEmailStatus: PartnerOrganizationStatus;
    riskAddressSuccess: PartnerOrganizationStatus;
    business: boolean;
    status: PartnerAccountStatusEnum;
    statusReason: string;
    onboardingRequest: PartnerOnboardingRequest;
    createOrganizationResponse: CreateOrganizationResponse;
    createPolicyResponses: CreatePolicyResponse;
    createAccountResponse: CreateAccountResponse;
    hubspotCompanyResponse: HubspotCompanyResponse;
    personaInquiryResponse: PersonaInquiryResponse;
    riskAddress: any;
    requestStartDate?: Date;
    coverageStartDate?: string;
    coverageEndDate?: string;
    createdDate: Date;
    lastModifiedDate: Date;
    createdByUser: string;
    modifiedByUser: string;
}

export enum PartnerOrganizationStatus {
    PENDING,
    COMPLETE,
    FAILED,
    SKIPPED
}

export enum PartnerAccountStatusEnum {
    ACTIVE = "ACTIVE",
    ACTIVE_CUSTOM = "ACTIVE_CUSTOM",
    ONBOARDING_IN_PROGRESS = "ONBOARDING_IN_PROGRESS",
    PENDING_ACTIVE = "PENDING_ACTIVE",
    ONBOARDING_TIMED_OUT = "ONBOARDING_TIMED_OUT",
    REJECTED = "REJECTED",
    PENDING_INACTIVE = "PENDING_INACTIVE",
    INACTIVE = "INACTIVE",
    TERMINATED = "TERMINATED",
    DELETED = "DELETED",
    STAGING = "STAGING"
}

export interface PartnerOnboardingRequest {
    id: string;
    firstName: string;
    lastName: string;
    websiteUrl: string;
    companyName: string;
    companyLegalName: string;
    companyDbaName: string;
    phone: string;
    email: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateCode: string;
    postalCode: string;
    countryCode: string;
    stripeAccountId: string;
    apiKey: string;
}

export interface CreateOrganizationResponse {
    organizationId: number;
    policyBillingMethodId: string;
    verificationBillingMethodId: string;
    invoiceDate: number;
    email: CreateOrganizationEmail;
    phone: CreateOrganizationPhone;
    address: CreateOrganizationAddress;
    notifyGuestVerification: number;
    safelyServiceId: string;
    forGuestVerification: number;
    forReservation: number;
    syncAllProperties: number;
    sourceId: string;
    autoChargeInvoice: number;
    isReceivingAlert: number;
    billingContactPhoneNumber: string;
    notificationEmail: string;
    billingContactEmailAddress: string;
    billingContactName: string;
    organizationName: string;
    orgNameToGuest: string;
    website: string;
    contactFirstName: string;
    contactLastName: string;
    sendCheckToSafely: number;
    paymentToken: string;
}

export interface CreateOrganizationEmail {
    isPrimary: number;
    emailAddress: string;
}

export interface CreateOrganizationPhone {
    isPrimary: number;
    phoneNumber: string;
}

export interface CreateOrganizationAddress {
    countryId: string;
    countryName: string;
    statusId: number;
    state: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    postalCode: string;
    country: CreateOrganizationCountry;
}

export interface CreateOrganizationCountry {
    id: string;
    displayText: string;
}

export interface CreatePolicyResponse {
    organizationId: string;
    statusId: number;
    insurancePolicyId: string;
    policyPriceId: number;
    accountId: number;
    isPrimary: number;
    id: number;
}

export interface CreateAccountResponse {
    accountId: number;
    roleId: string;
    requestFor: string;
    activationStatus: string;
}

export interface HubspotCompanyResponse {
    id: string;
    properties: HubspotProperties;
    createdAt: string;
    updatedAt: string;
    archived: boolean;
}

export interface HubspotProperties {
    name: string;
    domain: string;
    city: string;
    phone: string;
    state: string;
    country: string;
    lifecyclestage: string;
    portalOrganizationId: string;
    additionalProperties: any;
}

export interface PersonaInquiryResponse {
    data: PersonaInquiryResponseData;
}

export interface PersonaInquiryResponseData {
    type: string;
    id: string;
    attributes: any;
    relationships: any;
}

export interface RiskAddress {
    organizationAddress: boolean;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateCode: string;
    postalCode: string;
    countryCode: string;
}

export const ParnterOrganizationStatusColor = {
    ACTIVE: '#79c91c',
    ACTIVE_CUSTOM: '#008D73',
    ONBOARDING_IN_PROGRESS: '#f29b02',
    ONBOARDING_TIMED_OUT: '#600004',
    PENDING_ACTIVE: '#ffdd00',
    REJECTED: '#f60000ff',
    PENDING_INACTIVE: '#600004',
    INACTIVE: '#778898',
    TERMINATED: '#f60000ff',
    DELETED: '#f60000ff',
    STAGING: '#f29b02',
}
